import { useQuery } from '@tanstack/react-query';

import { stripeAccountRepo } from '@ctct/domain-layer';
import type { StripePortalDetailsPayload } from '@ctct/infrastructure-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useStripePortal = (body: StripePortalDetailsPayload, isStripeUser = true) => {
  const query = useQuery({
    queryKey: [QueryKeys.STRIPE_PORTAL],
    queryFn: () => stripeAccountRepo.getStripePortal(body),
    enabled: isStripeUser,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseStripePortal = ReturnType<typeof useStripePortal>;
